import {useStyles} from '../../../../shared/hooks/styles';

export const useCertificateTableStyles = () => {
  return useStyles(({theme}) => ({
    cellStyle: {
      flexBasis: 200,
    },
    colText: {
      ...theme.fonts.h5,
      color: theme.color.textColor,
    },
    colTextPrimary: {
      ...theme.fonts.h5,
      color: theme.color.primaryColor,
    },
  }));
};
